import React from 'react';

export function TransfersNormalColumnFormatter(cellContent) {
  return (
    <div className="d-block text-nowrap" style={{ color: '#333', fontSize: '16px' }}>
      {cellContent}
    </div>
  );
}
